import { SharedFeature } from '@com-delta-idp/mnx-skymiles-shared';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SKYCLUB_FEATURE_KEY,
  State,
  skyClubAdapter
} from '../reducers/sky-club.reducer';

import * as Adapters from '../../adapters';
import { getFullPageError } from '../../adapters/full-page-error.adapter';

// Lookup the 'Shared' feature state managed by NgRx
export const getSharedState = createFeatureSelector<SharedFeature.State>(
  SharedFeature.SHARED_FEATURE_KEY
);

const { selectEntities: selectSharedEntities } =
  SharedFeature.sharedAdapter.getSelectors();

export const getSharedEntities = createSelector(
  getSharedState,
  (state: SharedFeature.State) => {
    return selectSharedEntities(state);
  }
);

export const getMedallionMemberDesc = createSelector(
  getSharedEntities,
  (sharedEntities) =>
    sharedEntities['user-session']?.userSession?.medallionMemberDesc || ''
);

export const getMembershipLevel = createSelector(
  getSharedEntities,
  (sharedEntities) =>
    sharedEntities['user-session']?.userSession?.membershipLevel || ''
);

// Lookup the 'SkyClub' feature state managed by NgRx
export const getSkyClubState =
  createFeatureSelector<State>(SKYCLUB_FEATURE_KEY);

const { selectEntities } = skyClubAdapter.getSelectors();

export const getSkyClubEntities = createSelector(
  getSkyClubState,
  (state: State) => selectEntities(state)
);

export const getTitle = createSelector(getSkyClubEntities, (skyClubContent) =>
  Adapters.getTitle(skyClubContent['aem-content']?.aemContent?.overview?.header)
);

export const getOverview = createSelector(
  getSkyClubEntities,
  (skyClubContent) =>
    Adapters.getOverview(
      skyClubContent['aem-content']?.aemContent?.overview,
      undefined,
      true,
      skyClubContent['purchase-data']?.purchaseData
    )
);

export const getPurchase = createSelector(
  getSkyClubEntities,
  getMedallionMemberDesc,
  getMembershipLevel,
  (skyClubContent, medallionMemberDesc, membershipLevel) => {
    return Adapters.getPurchase(
      skyClubContent['aem-content']?.aemContent?.purchase,
      skyClubContent['purchase-data']?.purchaseData?.membershipDetailMap,
      skyClubContent['aem-content']?.aemContent?.errorMessages,
      [skyClubContent['purchase-data-error']?.purchaseDataError],
      true,
      medallionMemberDesc,
      membershipLevel
    );
  }
);

export const getCheckout = createSelector(
  getSkyClubEntities,
  (skyClubContent) =>
    Adapters.getCheckout(
      skyClubContent['aem-content']?.aemContent?.checkout,
      skyClubContent['add-to-cart-data']?.addToCart,
      skyClubContent['add-to-cart-data']?.value,
      skyClubContent['aem-content']?.aemContent?.errorMessages,
      [skyClubContent['add-to-cart-error']?.addToCartError],
      true
    )
);

export const getFullPageErrorMessage = createSelector(
  getSkyClubEntities,
  (skyClubContent) =>
    getFullPageError([skyClubContent['aem-content-error']?.aemContentError])
);
